const FETCH_SEARCH_ALL = 'search/FETCH_SEARCH_ALL';

const FETCH_SEARCH_STORIES = 'search/FETCH_SEARCH_STORIES';

const FETCH_SEARCH_TAGS = 'search/FETCH_SEARCH_TAGS';

const FETCH_SEARCH_USERS = 'search/FETCH_SEARCH_USERS';

const SET_SEARCHED_QUERY = 'search/SET_SEARCHED_QUERY';

const FETCH_POPULAR_TAGS = 'search/FETCH_POPULAR_TAGS';

const FETCH_TAG_RANKING = 'search/FETCH_TAG_RANKING';

const FETCH_RECOMMENDATIONS = 'search/FETCH_RECOMMENDATIONS';

const RESET_ALL = 'search/RESET_ALL';

const RESET_RECOMMENDATIONS = 'search/RESET_RECOMMENDATIONS';

export default {
  FETCH_SEARCH_ALL,
  FETCH_SEARCH_STORIES,
  FETCH_SEARCH_TAGS,
  FETCH_SEARCH_USERS,
  SET_SEARCHED_QUERY,
  FETCH_POPULAR_TAGS,
  FETCH_TAG_RANKING,
  FETCH_RECOMMENDATIONS,
  RESET_ALL,
  RESET_RECOMMENDATIONS,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/search/types.js